"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _input = require("Resources/components/elements/mixins/input");

var _input2 = _interopRequireDefault(_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["placeholder", "icon", "color", "backgroundColor", "iconColor", "name", "disabled", "type", "initialValue", "rows"],

  data: function data() {
    return {
      text: this.initialValue || ""
    };
  },


  mixins: [_input2.default],

  computed: {
    classes: function classes() {
      var baseClasses = ["input-wrapper", "clearfix"];

      baseClasses.push(this.inputTextColorClass);

      if (this.backgroundColor) {
        baseClasses.push("has-background-" + this.backgroundColor);
      }

      return baseClasses;
    },
    setIconColor: function setIconColor() {
      return this.inputIconColorClass;
    }
  },

  watch: {
    text: function text(value) {
      if (value.length > 2 || value.length === 0) {
        this.change();
      }
    },
    initialValue: function initialValue(value) {
      this.text = value || "";
    }
  },

  methods: {
    change: function change() {
      this.$emit("change", this.text);
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/TextareaField.vue
// module id = LhUA
// module chunks = 0 1